import React from "react";
import { CheckBox } from "components/base/base";
import { getModelConfig } from "../utils/constants";

const FieldsSelector = ({
  modelName = "purchase.order",
  selectedFields,
  setSelectedFields,
}) => {
  // 获取模型配置
  const { fieldDescriptions, availableFields, defaultSelectedFields } =
    getModelConfig(modelName);

  // 辅助函数
  const getSelectedFields = () =>
    Object.entries(selectedFields)
      .filter(([_, isSelected]) => isSelected)
      .map(([fieldName]) => fieldName);

  const toggleField = (fieldName) =>
    setSelectedFields({
      ...selectedFields,
      [fieldName]: !selectedFields[fieldName],
    });

  // 设置所有字段的选择状态
  const setAllFieldsSelection = (isSelected) => {
    const newSelectedFields = { ...selectedFields };
    Object.keys(newSelectedFields).forEach((key) => {
      newSelectedFields[key] = isSelected;
    });
    setSelectedFields(newSelectedFields);
  };

  // 只保留默认选中字段
  const setOnlyDefaultFields = () => {
    setSelectedFields({ ...defaultSelectedFields });
  };

  return (
    <div className="bg-gray-50 p-4 rounded-lg border mb-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-medium text-gray-700">查询字段</h3>
        <div className="flex space-x-2">
          <button
            className="text-xs bg-blue-100 hover:bg-blue-200 text-blue-800 py-1 px-2 rounded"
            onClick={() => setAllFieldsSelection(true)}
          >
            全选
          </button>
          <button
            className="text-xs bg-red-100 hover:bg-red-200 text-red-800 py-1 px-2 rounded"
            onClick={() => setOnlyDefaultFields()}
          >
            仅保留默认
          </button>
        </div>
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
          {availableFields.map((field) => (
            <div key={field.value} className="flex items-center">
              <CheckBox
                checked={selectedFields[field.value]}
                onChange={() => toggleField(field.value)}
                size={16}
              />
              <span
                className="ml-2 text-sm cursor-help"
                title={
                  field.label || fieldDescriptions[field.value] || field.value
                }
              >
                {field.value}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-2 text-xs text-gray-500">
        已选择 {getSelectedFields().length} 个字段
      </div>
    </div>
  );
};

export default FieldsSelector;
